/* This is list of user scopes in CMP, Don't change the user scope order, add new once at last */
export const scope = [
    'selfService.write',
    'orderMgmt.read',
    'orderMgmt.write', // This scope defines the user as Admin Role
    'approvalMgmt.write',
    'landingzoneMgmt.read',
    'landingzoneMgmt.write',
    'cmp.auth',
    'CMPBetaUsers', // This scope defines the user as BetaUser Role
    'nsg.write',
    'nsg.read',
    'platform.admin',
    'edap.admin',
    'cpe.admin',
];
export const SCOPE_SELF_SERVICE_WRITE = scope[0];
export const SCOPE_ORDER_MGMT_READ = scope[1];
export const SCOPE_ORDER_MGMT_WRITE = scope[2];
export const SCOPE_APPROVAL_MGMT_WRITE = scope[3];
export const SCOPE_LANDINGZONE_MGMT_READ = scope[4];
export const SCOPE_LANDINGZONE_MGMT_WRITE = scope[5];
export const SCOPE_CMP_AUTH = scope[6];
export const SCOPE_CMP_BETA_USERS = scope[7];
export const SCOPE_NSG_WRITE = scope[8];
export const SCOPE_NSG_READ = scope[9];
export const SCOPE_PLATFORM_ADMIN = scope[10];
export const SCOPE_EDAP_ADMIN = scope[11];
export const SCOPE_CPE_ADMIN = scope[12];

export default scope;
